export const BUSINESS_ENTERPRISE_SUCCESS_DESCRIPTION_NO_CHILI_DEMO = {
  "en": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "it": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "ja": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "ko": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "nl": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "pt-pt": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "sv": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>",
  "zh": "If you’d like to see Dashlane in action before you get started, visit our <a href=\"/demo\">Demo center.</a>"
}